import { render } from "./CustomerMail.vue?vue&type=template&id=0d02091c&scoped=true"
import script from "./CustomerMail.vue?vue&type=script&lang=js"
export * from "./CustomerMail.vue?vue&type=script&lang=js"

import "./CustomerMail.vue?vue&type=style&index=0&id=0d02091c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d02091c"]])

export default __exports__